<template>
  <div class="tw:bg-white">
    <div class="cta-container">
      <SignUpCtaSection title="Get a Full Vulnerability Report" />
    </div>

    <div>
      <VulnerabilityList />
    </div>
    <MainMarketApps />
  </div>
</template>
<script>
import VulnerabilityList from '../components/vulnerability/VulnerabilityList';
import MainMarketApps from '../components/main/MainMarketApps';
import SignUpCtaSection from '../components/@shared/SignUpCtaSection.vue';

export default {
  components: {
    MainMarketApps,
    VulnerabilityList,
    SignUpCtaSection,
  },
};
</script>

<style lang="scss" scoped>
.cta-container {
  margin: 2rem auto;

  @media screen and (max-width: 768px) {
    margin: 2rem 0 3rem;
  }
}
</style>
